import styled from "styled-components";
import { PillButton } from "../../../../../../CommonComponents/commonStyles";
import { Underlinelink } from "../../../Step1Setup/styles";
import { Content } from "../../styles";

export const CollapseWrap = styled.div`
  margin-bottom: 20px;
  .ant-collapse {
    background: #ffffff;
    border-radius: 0px;
  }

  .ant-collapse-header {
    padding-bottom: 0 !important;
  }

  .ant-collapse-content {
    border-top: none;
    .ant-collapse-content-box {
      padding-top: 0;
    }
  }

  border: 1px solid #d4d4d4;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

export const ContentWrap = styled(Content)`
  padding-left: 30px;
  line-height: 1.5;
  padding: 7px 0 20px 30px !important;
  a{
    color: #006778 !important;
    text-decoration: underline !important;
  }
  @media only screen and (max-width: 834px) {
    width: auto !important;
  }
`;

export const AccordionStatus = styled.div`
  margin-left: auto;
  margin-right: 30px;
  text-align: center;
`;

export const AccordionStatusText = styled.span`
  font-size: 16px;
  color: ${props => props.color};
  margin-left: 10px;
`;

export const PillButtonSelect = styled(PillButton)`
  &:hover,
  &:focus {
    color: #006778;
    border-color: #d4d4d4;
  }
  width: 135px;
  margin: 0 0 20px 30px;
  color: #006778;
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 20px 20px;
  }
`;

export const Title = styled.div`
  font-family: BerkeleyStd-Book;
  font-size: 24px;
  line-height: 1.17;
  padding-left: 30px;
  padding-top: 19px;
  color: ${props => props.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding-left: 20px;
    font-size: 18px;
  }
`;

export const DisplayFlexAlign = styled.div`
  display: flex;
  align-items: center;
`;

export const Percentage = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 1.17;
  color: ${props => props.textColor};
  padding: 7px 60px 20px 30px !important;
  @media only screen and (min-width: 320px) and (max-width: 475px) {
    padding-left: 20px;
  }
  @media only screen and (min-width: 475px) and (max-width: 768px) {
    padding-left: 30px;
  }
`;

export const UnderlinelinkRemove = styled(Underlinelink)`
  font-family: HelveticaNeue;
  line-height: normal;
  margin-left: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

export const Check = styled.div`
  display: ${props => props.displayType};
`;
